import {AmsListItemBase} from './AmsListItemBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export class AmsBranchListItem extends AmsListItemBase {
    amsID: string = '';
    branch: string = '';
    email: string = '';
    amsGroupId: number|null = null;
    id: number = 0;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'SCAC', width: 60, dataIndex: 'amsID', align: XCol.XAlignType.Right, defaultColumnFocus : true}),
        XCol.Create({ col: 2, text: 'Branch', width: 60, dataIndex: 'branch'}),
        XCol.Create({ col: 3, text: 'Email', width: 200, dataIndex: 'email'})
        ];


    public static getExportCollection(useBranch: boolean): XCol.XExportColumn[] {
        let returnCloumns = _.cloneDeep(this.ExportCollection);
        if (!useBranch) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'branch');
        return returnCloumns;
    };
	
    public static OrderBy = { orderBy: AmsBranchListItem.prototype.id, orderByAscending: false };

    public static formatData(data: AmsBranchListItem[]) {
        return data.map((d: AmsBranchListItem) => ({
          ...d,
        }));
    }

}
